import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { useApp } from '../context';
import { Action, Field } from '../ui';

function quantityError(quantity, minimum, maximum) {
  if (Number.isInteger(quantity) && quantity >= minimum && quantity <= maximum) return '';
  return `Enter a whole quantity between ${minimum} and ${maximum}.`;
}

function useProductOrder(product) {
  const { addItems } = useApp();
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(product.moq);
  const [sample, setSample] = useState(false);
  const [error, setError] = useState('');
  const changeQuantity = event => { setQuantity(event.target.value); setError(''); };
  const changeSample = event => {
    setSample(event.target.checked);
    setQuantity(event.target.checked ? 1 : product.moq);
    setError('');
  };
  const add = () => {
    const value = Number(quantity);
    const message = quantityError(value, sample ? 1 : product.moq, product.stock);
    if (message) { setError(message); return; }
    addItems([{ product, quantity: value }]);
    navigate(`/rfq${sample ? '?sample=true' : ''}`);
  };
  return { quantity, sample, error, changeQuantity, changeSample, add };
}

const OrderFields = ({ product }) => {
  const order = useProductOrder(product);
  return <>
    <div className="detail-order">
      <Field id="product-quantity" label={`Quantity (${product.unit})`} type="number"
        min={order.sample ? 1 : product.moq} max={product.stock} value={order.quantity} onChange={order.changeQuantity} />
      <Action id="product-request-quote" onClick={order.add}>Add to quote request<ArrowUpRight size={17} /></Action>
      <label className="checkbox-label"><input data-testid="sample-order-checkbox" type="checkbox"
        checked={order.sample} onChange={order.changeSample} />Request a sample</label>
      <span className="stock-label" data-testid="stock-available">{product.stock.toLocaleString()} {product.unit} available</span>
    </div>
    {order.error && <div className="notice error" data-testid="quantity-error" role="alert">{order.error}</div>}
  </>;
};

export const ProductActions = ({ product, user }) => {
  if (user && user.role !== 'buyer') return null;
  return <OrderFields key={product.id} product={product} />;
};